//used for get domain data
export const GET_DOMAINS = " GET_DOMAINS"
export const  GET_DOMAINS_SUCCESS = " GET_DOMAINS_SUCCESS"
export const  GET_DOMAINS_FAILED = " GET_DOMAINS_FAILED"
//used for delete domain
export const DOMAIN_DELETE = "DOMAIN_DELETE"
export const  DOMAIN_DELETE_SUCCESS = " DOMAIN_DELETE_SUCCESS"
export const  DOMAIN_DELETE_FAILED = " DOMAIN_DELETE_FAILED"

//used for delete domain
export const ADD_DOMAIN = "ADD_DOMAIN"
export const  ADD_DOMAIN_SUCCESS = " ADD_DOMAIN_SUCCESS"
export const  ADD_DOMAIN_FAILED = " ADD_DOMAIN_FAILED"

//used for delete domain
export const UPDATE_DOMAIN = "UPDATE_DOMAIN"
export const  UPDATE_DOMAIN_SUCCESS = " UPDATE_DOMAIN_SUCCESS"
export const UPDATE_DOMAIN_FAILED = " UPDATE_DOMAIN_FAILED"

//used for sample domain csv files
export const GET_SAMPLE_DOMIANS_CSV="GET_SAMPLE_DOMAINS_CSV"
export const GET_SAMPLE_DOMIANS_CSV_SUCCESS="GET_SAMPLE_DOMAINS_CSV_SUCCESS"
export const GET_SAMPLE_DOMIANS_CSV_FAILED="GET_SAMPLE_DOMAINS_CSV_FAILED"

//used for bulk import domains
export const BULKIMPORT_DOMAINS="BULKIMPORT_DOMAINS"
export const BULKIMPORT_DOMAINS_SUCCESS="BULKIMPORT_DOMAINS_SUCCESS"
export const BULKIMPORT_DOMAINS_FAILED="BULKIMPORT_DOMAINS_FAILED"